import {
  DEFAULT_WASTE_CREATE_FORM,
  DEFAULT_WASTE_FORM,
} from "./wasteFlowConstants";

const baseWasteTemplateData = {
  hazardous: false,
  unCodeFull: "",
  unCodeEmpty: "",
  wasteCodeFull: "",
  wasteCodeEmpty: "",
  transportCost: 0,
  treatmentCostFull: "",
  treatmentCostEmpty: 0,
  treatmentCostUnit: "ton",
  compactionFactor: 1,
  active: true,
};

const WASTE_FLOW_TEMPLATE_IDS = {
  wood: "wood",
  cardboard: "cardboard",
  greenwaste: "greenwaste",
  incinerable: "incinerable",
  metal: "metal",
  mixedWaste: "mixed-waste",
  plastic: "plastic",
  rubble: "rubble",
};

export function getWasteFlowTemplates(t) {
  return [
    {
      id: WASTE_FLOW_TEMPLATE_IDS.wood,
      label: t("Wood"),
      icon: "🪵",
      data: {
        ...baseWasteTemplateData,
        value: t("Wood"),
        label: t("Wood"),
        density: 168,
        displayColor: "#fcdc00",
        authorizedMaterial: [
          { name: "wood", value: "wood", parentCategory: "wood" },
          { name: "wood_crate", value: "wood_crate", parentCategory: "wood" },
          { name: "wood_pallet", value: "wood_pallet", parentCategory: "wood" },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.cardboard,
      label: t("Cardboard"),
      icon: "📦",
      data: {
        ...baseWasteTemplateData,
        value: t("Cardboard"),
        label: t("Cardboard"),
        density: 60,
        displayColor: "#F59E0B",
        authorizedMaterial: [
          {
            name: "cardboard",
            value: "cardboard",
            parentCategory: "cardboard",
          },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.greenwaste,
      label: t("Greenwaste"),
      icon: "🌿",
      data: {
        ...baseWasteTemplateData,
        value: t("Greenwaste"),
        label: t("Greenwaste"),
        density: 200,
        displayColor: "#22C55E",
        authorizedMaterial: [
          { name: "organic", value: "organic", parentCategory: "other" },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.incinerable,
      label: t("Incinerable"),
      icon: "🔥",
      data: {
        ...baseWasteTemplateData,
        value: t("Incinerable"),
        label: t("Incinerable"),
        density: 200,
        displayColor: "#F97316",
        authorizedMaterial: [
          {
            name: "trashbag_black",
            value: "trashbag_black",
            parentCategory: "other",
          },
          {
            name: "trashbag_colored",
            value: "trashbag_colored",
            parentCategory: "other",
          },
          {
            name: "trashbag_transparent",
            value: "trashbag_transparent",
            parentCategory: "other",
          },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.metal,
      label: t("Metal"),
      icon: "🔩",
      data: {
        ...baseWasteTemplateData,
        value: t("Metal"),
        label: t("Metal"),
        density: 162,
        displayColor: "#94A3B8",
        authorizedMaterial: [
          { name: "metal", value: "metal", parentCategory: "metal" },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.mixedWaste,
      label: t("Mixed Waste"),
      icon: "😞",
      data: {
        ...baseWasteTemplateData,
        value: t("Mixed Waste"),
        label: t("Mixed Waste"),
        density: 345,
        displayColor: "#FF0000",
        authorizedMaterial: [
          {
            name: "non_recyclable_waste",
            value: "non_recyclable_waste",
            parentCategory: "other",
          },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.plastic,
      label: t("Plastic"),
      icon: "🧴",
      data: {
        ...baseWasteTemplateData,
        value: t("Plastic"),
        label: t("Plastic"),
        density: 168,
        displayColor: "#0EA5E9",
        authorizedMaterial: [
          {
            name: "plastic_rigid",
            value: "plastic_rigid",
            parentCategory: "plastic",
          },
          { name: "plastic", value: "plastic", parentCategory: "plastic" },
          { name: "pvc", value: "pvc", parentCategory: "plastic" },
          {
            name: "plastic_flexible",
            value: "plastic_flexible",
            parentCategory: "plastic",
          },
          {
            name: "plastic_film",
            value: "plastic_film",
            parentCategory: "plastic",
          },
          {
            name: "plastic_coated",
            value: "plastic_coated",
            parentCategory: "plastic",
          },
        ],
      },
    },
    {
      id: WASTE_FLOW_TEMPLATE_IDS.rubble,
      label: t("Rubble"),
      icon: "🧱",
      data: {
        ...baseWasteTemplateData,
        value: t("Rubble"),
        label: t("Rubble"),
        density: 1400,
        displayColor: "#9CA3AF",
        authorizedMaterial: [
          { name: "rubble", value: "rubble", parentCategory: "mineral" },
        ],
      },
    },
  ];
}

export function getWasteFlowTemplateById(templateId, t) {
  if (!templateId) return null;
  return (
    getWasteFlowTemplates(t).find((template) => template.id === templateId) ||
    null
  );
}

export function buildWasteFlowCreateDataFromTemplate(template) {
  if (!template?.data) return { ...DEFAULT_WASTE_CREATE_FORM };
  return {
    ...DEFAULT_WASTE_FORM,
    ...DEFAULT_WASTE_CREATE_FORM,
    ...template.data,
  };
}
